<template>
  <div class="Multiline">
    <div class="layout_head has_theme color_1577FE">
      <p class="head_p has_theme color_1577FE">
        {{ dynamicTitle }} </p>
      <ul class="head_tabs has_theme color_1577FE">
  
      </ul>
      <div class="head_a_list">
        <a style="display: block" class="head_a has_theme hover_theme color_1577FE color_1577FE_hover" @click="toPage">
          更多+
        </a>
      </div>
    </div>
    <div class="main_body">
      <slot></slot>
  
  
    </div>
  </div>
</template>
<script>
export default {
  // 声明接收父组件传入的标题
  props: {
    dynamicTitle: {
      type: String, // 限制为字符串类型
      default: '' // 可设置默认值（可选）
    },
    jumpPath: {  // 新增prop接收跳转路径
      type: String,
      required: true  // 强制要求父组件必须传值
    }
  },
  methods: {
    toPage() { this.$router.push(this.jumpPath); }
  }
}
</script>
<style lang="scss" scoped>
.Multiline {
  .color_1577FE {
    color: #1577fe;
  }

  .layout_head {
    height: 40px;
    border-bottom: 1px solid #dfdfdf;
    position: relative;

    .head_tabs {
      float: left;
      padding-left: 20px;
      height: 30px;
    }

    .head_a_list {
      float: right;
      padding-right: 20px;
      height: 30px;

      .head_a {
        float: right;
        margin-top: 16px;
        line-height: 14px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }




  .head_p {
    position: relative;
    float: left;
    line-height: 30px;
    font-size: 24px;
    font-weight: 500;
  }

  .color_1577FE {
    color: #1577fe;
  }

  .color_1577FE_hover:hover {
    color: #1577fe !important;
  }

  .color_1577FE::before {
    background-color: #1577fe;
  }

  .layout_head::before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 52px;
    height: 2px;
  }

  .main_body {
    padding-top: 30px;
    padding-bottom: 15px;



    .list {
      width: 120%;
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>